// Packages
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Components
import ListItem from 'modules/PurchaseOrders/components/ListItem';

// Other
import './styles.css';

const PurchaseOrderList = ({ isLoading, items, onChange, query }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='PurchaseOrderList'>
					<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No results</h3>
		)
	}


	// Data State
	return (
		<div className='PurchaseOrderList'>

			<div className='PurchaseOrderList__th tr'>
				<div className='semi-bold'>#</div>
				<div className='semi-bold'>Date</div>
				<div className='semi-bold'>Supplier</div>
				<div className='centre semi-bold'>Total</div>
				<div className='semi-bold centre'>Status</div>
			</div>

			{items.map((item, index) => {

				return (
						<Link className='PurchaseOrderList__link' to={'/purchaseorders/' + item.id + (query !== '' ? '?query=' + query : '')} key={index}>
							<ListItem 
								{...item} 
								isLoading={false}
								onChange={() => {onChange()}}
							/>
						</Link>
				)
				
			})}

		</div>
	)
}

PurchaseOrderList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
	query: PropTypes.string
}

PurchaseOrderList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
	query: ''
}

export default PurchaseOrderList;